import i18n from '@/i18n';
import { DEFAULT_LOCALE, normalizeLocale } from '@/locales';
import { getStoredLocale, saveLocale } from '@/shared/helpers/localeStorage';

export { LOCALE_STORAGE_KEY, getStoredLocale } from '@/shared/helpers/localeStorage';
export { DEFAULT_LOCALE, isSupportedLocale, normalizeLocale } from '@/locales';
export { SUPPORTED_LOCALES } from '@/locales';

export const resolveInitialLocale = (brandingLang) => {
  const stored = getStoredLocale();
  if (stored) {
    return stored;
  }

  if (brandingLang) {
    const normalized = String(brandingLang).toLowerCase() === 'zh-hk'
      ? 'zh-HK'
      : String(brandingLang).toLowerCase();
    return normalizeLocale(normalized);
  }

  return DEFAULT_LOCALE;
};

export const setLanguage = (lang) => {
  const locale = normalizeLocale(lang);
  i18n.locale = locale;

  saveLocale(locale);
};

export const getLanguage = () => {
  return i18n.locale;
};
